import { axiosIDP } from '@/plugins/axios';

/** API_URL_DECONNEXION_PATIENT env var */
declare const API_URL_DECONNEXION_PATIENT: string;

export function deconnexionPatient(): Promise<boolean> {
	return axiosIDP.get(API_URL_DECONNEXION_PATIENT);
}
